export default __webpack_public_path__ + "static/TrustLPHeader-c540dca47d233f5482588ffa96b7dce3.webp";